import styled from "styled-components";
import { TEXT_SECONDARY } from "@streeteasy/design-system/colors";
import { Body } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const ResourcesContainer = styled.div`
  margin: 0 auto;
  max-width: 1404px;
  padding: 64px 48px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 46px 24px 48px;
  }
`;

export const Text = styled(Body)`
  color: ${TEXT_SECONDARY};
`;
